var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mall-month-data-detail"},[_c('div',{staticClass:"detail-content"},[_c('div',{staticClass:"detail-content__inner"},[_c('div',{staticClass:"chart-title"},[_vm._v(_vm._s(_vm.data.name)+"收益")]),_c('div',{staticClass:"chart-content"},[_c('MallMonthDataDetailChart2',{attrs:{"list":_vm.chartList}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }